var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobal = function SvgGlobal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 5.5,
    stroke: "#93278F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    fillRule: "nonzero",
    d: "M6.253 1C4.27 2.082 3 4.274 3 6.704c0 2.421 1.261 4.608 3.235 5.693l.497-.833C5.076 10.654 4 8.788 4 6.704c0-2.091 1.083-3.961 2.747-4.869z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    fillRule: "nonzero",
    d: "M6.494 1c1.983 1.082 3.253 3.274 3.253 5.704 0 2.421-1.261 4.608-3.235 5.693l-.497-.833c1.656-.91 2.732-2.776 2.732-4.86 0-2.091-1.083-3.961-2.747-4.869z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#93278F",
    strokeLinecap: "square",
    d: "M6.5 1.423v10.154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    fillRule: "nonzero",
    d: "M.923 7h11.154V6H.923zM1 5h11V4H1zM1 9h11V8H1z"
  }))));
};
export default SvgGlobal;